export var pressedStyle = "\n  transform: translateY(2px);\n";
export var activePressedStyle = "\n  &:active {\n    " + pressedStyle + "\n  }\n";